import React from 'react';
import './TitlePage.scss';
import { useMediaQuery } from 'react-responsive';
import { useLocation } from 'react-router-dom';
import BackgroundImageWithSkeleton from '../BackgroundImageWithSkeleton/BackgroundImageWithSkeleton';

const TitlePage = ({title1, font1, title2, font2, picture, withSubscribeBtn=false}) => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const location = useLocation();

    const height = !isMobile ? '450px' : (withSubscribeBtn ? '375px' : '300px');

    const withOpacity = location.pathname === '/ateliers-parentalite' || 
                             location.pathname === '/programmes-en-ligne' ||
                             location.pathname === '/ateliers/ateliers-presentiel' ||
                             location.pathname === '/astro-parentalite';

    return (
        <div className="titlePage"
            style={{
                height,
            }}    
        >
            <BackgroundImageWithSkeleton
                picture={picture ? picture : null}
                width='100%'
                height={height}
                opacityBlock={withOpacity}
                positionMobile='absolute'
                positionDesktop='fixed'
            />
            <h1
                style={{
                    marginTop: !isMobile ? 80 : (withSubscribeBtn ? -150 : 0)
                }}
            >
                <span className={font1}>{title1}</span>
                <span className={font2}>{title2}</span>
            </h1>
        </div>
    );
};

export default TitlePage;